const features = [
  {
    link: 'calculate-aggregate-score',
    color: '#f39c12',
    heading: 'Calculate your aggregate score',
    imgSrc: 'calculator.svg',
    imgAlt: 'Aggregate calculator',
    description: 'This is a simple calculator that helps you calculate your aggregate score.'
  },
  {
    link: 'admission-probability',
    color: '#27ae60',
    heading: 'Check your probability of gaining admission',
    imgSrc: 'graph.svg',
    imgAlt: 'Admission probability',
    description: 'This gives you an estimated probability of gaining admission to your school of choice.'
  },
  {
    link: 'course-requirements',
    color: '#c0392b',
    heading: 'View course requirements',
    imgSrc: 'note.svg',
    imgAlt: 'Course requirements',
    description: 'Checkout the subjects you must have in order to gain admission to your school of choice.'
  },
  {
    link: 'news',
    color: '#8e44ad',
    heading: 'News update',
    imgSrc: 'newspaper.svg',
    imgAlt: 'News update',
    description: 'Get the latest news and gist about J.A.M.B, post-U.T.M.E, Nigerian universities and so on.'
  },
  {
    link: 'question',
    color: '#7f8c8d',
    heading: 'Ask or answer a question',
    imgSrc: 'question.svg',
    imgAlt: 'Question',
    description: 'Ask any appropriate question you might have or help someone by answering their question.'
  },
  {
    link: 'post-utme-score',
    color: '#2980b9',
    heading: 'Check your post-U.T.M.E score',
    imgSrc: 'score.svg',
    imgAlt: 'post-U.T.M.E score',
    description: 'Do you know your post-U.T.M.E score? Check it out here!'
  }
];

export default features;
